var _path, _path2, _g, _circle, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPendingImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 211,
    viewBox: "0 0 212 211",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M106 211C164.266 211 211.5 163.766 211.5 105.5C211.5 47.234 164.266 0 106 0C47.734 0 0.5 47.234 0.5 105.5C0.5 163.766 47.734 211 106 211Z",
    fill: "#F7F9FA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4178_1435",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 212,
    height: 211
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M106 211C164.266 211 211.5 163.766 211.5 105.5C211.5 47.234 164.266 0 106 0C47.734 0 0.5 47.234 0.5 105.5C0.5 163.766 47.734 211 106 211Z",
    fill: "#F7F9FA"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4178_1435)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.5,
    y: 63.5098,
    width: 119.041,
    height: 169.001,
    rx: 4,
    fill: "white",
    stroke: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 81,
    width: 35,
    height: 5,
    fill: "#C6CAC9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 89,
    width: 103,
    height: 18,
    fill: "#EDEFF0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 117,
    width: 35,
    height: 5,
    fill: "#C6CAC9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 125,
    width: 91,
    height: 9,
    fill: "#EDEFF0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 146,
    width: 35,
    height: 4,
    fill: "#C6CAC9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 154,
    width: 103,
    height: 61,
    fill: "#EDEFF0"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 33,
    r: 25,
    fill: "#1B8379"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M180 45C177.215 45 174.545 43.8938 172.575 41.9247C170.606 39.9555 169.5 37.2848 169.5 34.5C169.5 31.7153 170.606 29.0445 172.575 27.0754C174.545 25.1063 177.215 24 180 24C182.785 24 185.455 25.1063 187.425 27.0754C189.394 29.0445 190.5 31.7153 190.5 34.5C190.5 37.2848 189.394 39.9555 187.425 41.9247C185.455 43.8938 182.785 45 180 45ZM180 21C176.42 21 172.986 22.4224 170.454 24.9541C167.922 27.4858 166.5 30.9196 166.5 34.5C166.5 38.0805 167.922 41.5142 170.454 44.046C172.986 46.5777 176.42 48 180 48C183.58 48 187.014 46.5777 189.546 44.046C192.078 41.5142 193.5 38.0805 193.5 34.5C193.5 30.9196 192.078 27.4858 189.546 24.9541C187.014 22.4224 183.58 21 180 21ZM180.75 27H178.5V36L185.625 40.275L186.75 38.43L180.75 34.875V27ZM173.82 20.085L171.9 17.79L165 23.565L166.935 25.86L173.82 20.085ZM195 23.58L188.1 17.79L186.165 20.085L193.065 25.875L195 23.58Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingImg);
export default __webpack_public_path__ + "static/media/pendingImg.57d4587d913d6039051f6bd888c98e82.svg";
export { ForwardRef as ReactComponent };